export function handleInput(e, kind, data, setData){
    if(e.target){
        switch(e.target.name) {
            case "name":
                setData( data = { ...data,
                    name: e.target.value
                })
                return null
            default:
                break;
        }
    }else{
        if(kind === "client"){
            setData( data = { ...data,
                client: e
            });
            return null
        }else if(kind === "room"){
            setData( data = { ...data,
                room: e
            });
            return null
        }
    }
}


// WEBPACK FOOTER //
// ./src/components/general/vouchersFormWrapper/handleInput.js